// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';
import { useEffect } from 'react';

export const useStatusBarColor = (color: string) => {
  useEffect(() => {
    const updateStatusBarColor = (color: string) => {
      let themeColorMetaTag = document.querySelector('meta[name="theme-color"]');

      if (!themeColorMetaTag) {
        themeColorMetaTag = document.createElement('meta');
        themeColorMetaTag.setAttribute('name', 'theme-color');
        document.head.appendChild(themeColorMetaTag);
      }

      if (themeColorMetaTag instanceof HTMLMetaElement) {
        themeColorMetaTag.content = color;
      }
    };

    updateStatusBarColor(color);

    return () => {
      updateStatusBarColor(COLORS.BACKGROUND_COLORS.WHITE);
    };
  }, [color]);
};
